var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm error-form",
      attrs: {
        model: _vm.formData,
        "label-width": "0",
        size: "small",
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.formData.arr, border: "" } },
        [
          _c(
            "el-table-column",
            {
              attrs: { prop: "feeTypeCode", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "arr." + scope.$index + ".feeTypeCode",
                            rules: {
                              required: true,
                              message: _vm.$t("basicData.CannotBeEmpty"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("basicData.PleaseSelect"),
                              },
                              model: {
                                value: scope.row.feeTypeCode,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "feeTypeCode", $$v)
                                },
                                expression: "scope.row.feeTypeCode",
                              },
                            },
                            _vm._l(_vm.feeTypeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.displayName + "(" + item.code + ")",
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _c("span", [_vm._v(_vm._s(_vm.$t("basicData.ExpenseType")))]),
                ]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { "min-width": "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "arr." + scope.$index + ".startWeight",
                            rules: {
                              required: true,
                              negative: "",
                              suffix: 3,
                              negative1: 1,
                              package: scope.row.endWeight,
                              validator: _vm.weightType,
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: scope.row.startWeight,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "startWeight", $$v)
                              },
                              expression: "scope.row.startWeight",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("receivablePayable.weightStart"))),
                  ]),
                ]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { "min-width": "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "arr." + scope.$index + ".endWeight",
                            rules: {
                              required: true,
                              negative: "",
                              suffix: 3,
                              negative1: 2,
                              package: scope.row.startWeight,
                              validator: _vm.weightType,
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: scope.row.endWeight,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "endWeight", $$v)
                              },
                              expression: "scope.row.endWeight",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("receivablePayable.weightEndInclusive"))
                    ),
                  ]),
                ]),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { "min-width": "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "arr." + scope.$index + ".price",
                                rules: {
                                  required: true,
                                  suffix: 2,
                                  negative: "",
                                  validator: _vm.weightType,
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: scope.row.price,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "price", $$v)
                                  },
                                  expression: "scope.row.price",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("receivablePayable.priceRange"))),
                  ]),
                ]),
              ]),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.operate"),
              fixed: "right",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDel(scope.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Delete")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }